module.exports = __webpack_public_path__ + "static/media/logo.b36a8625.png";